module.exports = __webpack_public_path__ + "static/media/gal1.b6ef4627.jpeg";